export default "__VITE_ASSET__7c13c3c9__"